export const getSessionStorageData = (tenant: string, version: string) => {
	const savedData = sessionStorage.getItem(`wizard_${tenant}_${version}`);
	if (savedData) {
		return JSON.parse(savedData);
	}

	return {};
}

export const setSessionStorageData = (tenant: string, version: string, data: any) => {
	sessionStorage.setItem(
		`wizard_${tenant}_${version}`,
		JSON.stringify(data)
	);
}